import "quasar/dist/quasar.css";
import "@quasar/extras/material-icons/material-icons.css";
import { Notify, Dialog, Dark } from "quasar";

// To be used on app.use(Quasar, { ... })
export default {
  config: {
    // Brand-paletten ska följa sajtens CSS-variabler (definierade i App.vue).
    // primary = "ink" (svart i light, off-white i dark) - används på knappar,
    // checkboxar och input-focus så de inte konkurrerar med röd-accenten som
    // är reserverad för menylänkar och ticket-CTA:n.
    // accent = sajtens röda accent - används där vi vill ha den röda
    // betoningen (kan refereras via Quasar:s `color="accent"`).
    // Override i dark mode görs via --q-primary i App.vue:s CSS.
    brand: {
      primary: "#1a1a1a",
      secondary: "#555",
      accent: "#cc1100",
      red: "#cc1100",
      blue: "#3E5669",
      purple: "#31087B",
      pink: "#FA2FB5",
      hej: "#FFC23C",
      black: "#100720",
    },
    extras: [
      "material-icons",
      "mdi-v6",
      "ionicons-v4", // last webfont was available in v4.6.3
      "eva-icons",
      "fontawesome-v6",
      "themify",
      "line-awesome",
      "bootstrap-icons",
    ],
  },
  plugins: {
    Notify,
    Dialog,
    Dark,
  },
};
